import {
    Home,

    LocationOn,
    List,

    TipsAndUpdates,
    GifBox,
    Sync

} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'
import {useState} from "react";


const Sidebar = () => {

    // keeping track of active page
    const [active, setActive] = useState(0)
    const nav = useNavigate()







    return (
        <>
            <div className="is-flex is-flex-direction-column is-justify-content-start rightmenu p-3 my-3 ">


                <div className={`dashboard__menu ${active === 0 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin');
                    setActive(0)
                }}>

                    <Home/>
                    <h3>داشبورد</h3>
                </div>


                <div className={`dashboard__menu ${active === 1 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/centers');
                    setActive(1)
                }}>

                    <GifBox/>
                    <h3>مراکز پستی</h3>
                </div>

                <div className={`dashboard__menu ${active === 2 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcels');
                    setActive(2)
                }}>

                    <List/>
                    <h3>گزارشات مرسوله ها</h3>
                </div>

                <div className={`dashboard__menu ${active === 3 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcels-city');
                    setActive(3)
                }}>

                    <LocationOn/>
                    <h3>گزارشات مرسوله بر اساس شهر</h3>
                </div>

                <div className={`dashboard__menu ${active === 4 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcels-status');
                    setActive(4)
                }}>

                    <Sync/>
                    <h3>گزارشات مرسوله بر اساس وضعیت</h3>
                </div>


                <div className={`dashboard__menu ${active === 5 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/about');
                    setActive(5)
                }}>
                    <TipsAndUpdates/>
                    <h3> راهنمای پنل</h3>
                </div>


            </div>

        </>
    )
}
export default Sidebar;